import {
	SCHEDULED_CHAT_DAYS,
	type ScheduledChatDayOfWeek,
	type ScheduledChatFrequency,
} from '@atlassian/conversation-assistant-message-actions-api/scheduled-chat';

import messages from './messages';
import type { FormatDateFn, FormatMessageFn } from './types';

const WEEKDAY_REF_ANCHOR = new Date(2024, 0, 1);

export const frequencyLabelFor = (
	frequency: ScheduledChatFrequency,
	formatMessage: FormatMessageFn,
): string => {
	switch (frequency) {
		case 'hourly':
			return formatMessage(messages.frequencyOptionHourly);
		case 'daily':
			return formatMessage(messages.frequencyOptionDaily);
		case 'weekdays':
			return formatMessage(messages.frequencyOptionWeekdays);
		case 'custom':
			return formatMessage(messages.frequencyOptionCustom);
		default:
			return frequency;
	}
};

export const weekdayLabelFor = (day: ScheduledChatDayOfWeek, formatDate: FormatDateFn): string => {
	const index = SCHEDULED_CHAT_DAYS.indexOf(day);
	const d = new Date(WEEKDAY_REF_ANCHOR);
	d.setDate(d.getDate() + index);
	return formatDate(d, { weekday: 'long' });
};

export const validateScheduledChatPayload = (
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	payload: any,
): {
	isValid: boolean;
	errors: string[];
} => {
	const errors: string[] = [];

	if (!payload.name?.trim()) {
		errors.push('Name is required');
	}

	return {
		isValid: errors.length === 0,
		errors,
	};
};
